define.alias("ember-math-helpers/helpers/trunc", "media/helpers/trunc");